<div class="headerimg">
  <div class="homeoverlay">
    Osservatorio Meteo-Idrologico della Regione Liguria
    <div class="homesubtitle">
      Omirl è la rete osservativa in tempo reale dei dati meteo-idrologici della
      Liguria
    </div>
  </div>
  <img fxHide.xs src="assets/img/header-home-xl.png" />
  <img fxHide.gt-xs src="assets/img/header-home-sm.png" />
</div>
<div id="home-container">
  <section id="home-body">
    <mat-card class="mat-elevation-z0">
      <mat-card-title> </mat-card-title>

      <div style="display: flex; justify-content: center; align-items: center">
        <mat-card-content>
          <div class="containerX">
            <div
              fxLayout="row"
              fxLayout.lt-sm="column"
              fxFlex
              class="coloredContainerX box"
            >
              <div fxLayout="row">
                <div fxFlex class="world">
                  <a href="dati">
                    <div align="center">
                      <img src="assets/img/dati.png" />
                    </div>

                    <div align="center">
                      <header>DATI</header>
                    </div>

                    <p align="center">
                      Osservazioni georiferite di parametri meteo-marini e
                      idrologici in tempo reale sulla Liguria
                    </p>
                  </a>
                </div>

                <div fxFlex class="world">
                  <a href="tabelle/sensorstable/Pluvio">
                    <div align="center">
                      <img src="assets/img/tabelle.png" />
                    </div>

                    <div align="center">
                      <header>TABELLE</header>
                    </div>

                    <p align="center">Elaborazione dati osservati</p>
                  </a>
                </div>
              </div>

              <div fxLayout="row">
                <div fxFlex class="world">
                  <a href="satellite-radar">
                    <div align="center">
                      <img src="assets/img/radar.png" />
                    </div>

                    <div align="center">
                      <header>SATELLITE E RADAR</header>
                    </div>

                    <p align="center">
                      Mappe di precipitazioni e nuvolosità elaborate da sensori
                      remoti
                    </p>
                  </a>
                </div>

                <div fxFlex class="world">
                  <a href="models-gallery">
                    <div align="center">
                      <img src="assets/img/mappa-marina.png" />
                    </div>

                    <div align="center">
                      <header>MODELLI METEO MARINI</header>
                    </div>

                    <p align="center">
                      Mappe di previsioni dei principali parametri meteo-marini
                    </p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </div>
    </mat-card>
  </section>
</div>

<h3 class="funds" align="center">Sito realizzato con i fondi</h3>
<div
  fxLayout="row"
  fxLayout.lt-sm="column"
  fxLayoutGap.lt-sm="30px"
  fxLayoutAlign="space-evenly center"
  class="logorow"
>
  <div fxLayout="row" fxLayoutAlign="center flex-start">
    <img class="logo-footer marittimo" src="assets/img/alcotra.png" />
  </div>

  <div fxLayout="row" fxLayoutAlign="center flex-start">
    <img class="logo-footer marittimo" src="assets/img/riskact.png" />
  </div>

  <div fxLayout="row" fxLayoutAlign="center flex-start">
    <img class="logo-footer marittimo" src="assets/img/regionelig.png" />
  </div>

  <div fxLayout="row" fxLayoutAlign="center flex-start">
    <img class="logo-footer marittimo" src="assets/img/arpal.png" />
  </div>

  <div fxLayout="row" fxLayoutAlign="center flex-start">
    <img class="logo-footer marittimo" src="assets/img/cima.png" />
  </div>
</div>

<h3 class="funds" align="center">
  Sito realizzato nella prima versione tramite il fondo europeo
</h3>
<div
  fxLayout="row"
  fxLayout.lt-sm="column"
  fxLayoutGap.lt-sm="30px"
  fxLayoutAlign="space-evenly center"
  class="logorow"
>
  <div fxLayout="row" fxLayoutAlign="center flex-start">
    <img class="logo-footer marittimo" src="assets/img/logo-marittimo2.png" />
  </div>

  <div fxLayout="row" fxLayoutAlign="center flex-start">
    <img class="logo-footer marittimo" src="assets/img/arpal.png" />
  </div>

  <div fxLayout="row" fxLayoutAlign="center flex-start">
    <img class="logo-footer marittimo" src="assets/img/cima.png" />
  </div>

  <div fxLayout="row" fxLayoutAlign="center flex-start">
    <img class="logo-footer marittimo" src="assets/img/proterina.png" />
  </div>
</div>
